<template>
  <el-submenu :index="index.toString()">
    <span slot="title">{{label}}</span>
    <template v-for="(item,i) in route">
        <el-menu-item :key="item.id" v-if="!item.children||!item.children.length" :index="item.href">{{item.label}}</el-menu-item>
        <menu-item :index="index+'-'+i" v-else :route="item.children" :key="item.id"></menu-item>
      </template>
  </el-submenu>
</template>
<script>
export default {
  name: "menuItem",
  props:["route","index","label"]
}
</script>